module.exports = __webpack_public_path__ + "static/media/visa.77441b38.svg";